import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { UI_LANGUAGES } from '@b4b/shared';
import cs from './locales/cs.json';
import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import pt from './locales/pt.json';
import de from './locales/de.json';
import ru from './locales/ru.json';
import hi from './locales/hi.json';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      cs: { translation: cs },
      en: { translation: en },
      es: { translation: es },
      fr: { translation: fr },
      pt: { translation: pt },
      de: { translation: de },
      ru: { translation: ru },
      hi: { translation: hi },
    },
    fallbackLng: 'en',
    supportedLngs: [...UI_LANGUAGES],
    nonExplicitSupportedLngs: true, // en-GB → en, pt-BR → pt
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'b4b-lang',
      caches: ['localStorage'],
    },
  });

// keep <html lang> in sync for screen readers / hyphenation (landing switcher, settings, server sync)
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});
if (i18n.resolvedLanguage) document.documentElement.lang = i18n.resolvedLanguage;

export default i18n;
